<ng-container *ngIf="itemsObservable | async as faqs">
	<!-- #region Title -->
	<div layout="column" *ngIf="faqs?.length > 0">
		<div class="title md-title tc-grey-500 pad-bottom" layout="row" i18n>FAQs</div>
	</div>
	<!-- #endregion -->

	<!-- #region FAQ question & answers -->
	<mat-accordion>
		<mat-expansion-panel *ngFor="let item of faqs">
			<mat-expansion-panel-header>
				<mat-panel-title>{{item.question}}</mat-panel-title>
			</mat-expansion-panel-header>
			<div [innerHTML]="item.answer"></div>
		</mat-expansion-panel>
	</mat-accordion>
	<!-- #endregion -->
</ng-container>